<template>
  <div class="main_wrap">
    <div class="loginindex">
      <div class="userSetBox">
        <div class="userinfo_box">
          <div class="user_box" style="border: none;">
            <div class="el-dropdown" style="width: 150px;">
              <div class="user_img">
                <img src="/ssologin/static/images/user_icon.png">
                <span class="user_name">{{userInfo.name}}</span>
              </div>
              <ul class="subset_nav">
                <div style="position:absolute;height: 30px;width: 100%;top:-30px;left:0;"></div>
                <li @click="gosetting('/Set/userinfo')">个人信息</li>
                <li @click="gosetting('/Set/groupManagement')" v-if="funList.length > 0">系统设置</li>
                <li @click="gosetting('/Set/systemLog')">日志审计</li>
                <li @click="gosetting('/exit')">退出</li>
                <div class="popper__arrow"></div>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="login-box">
        <a :href="oaUrl"><div class="onebox" v-if="id1"><div class="ico oa"></div>网络安全和舆情OA管理</div></a>
        <a :href="mediaUrl"><div class="onebox" v-if="id2"><div class="ico media"></div>网络信息发布审核和新媒体备案管理</div></a>
      </div>
    </div>

    <div>
      <ul class="bg">
        <li
          :class="[index == 0 ? 'show' : '']"
          :style="{ backgroundImage:  'url(' + require('../../static/images/bg1.jpg') +')' }"
        ></li>
        <li
          :class="[index == 1 ? 'show' : '']"
          :style="{ backgroundImage:  'url(' + require('../../static/images/bg2.jpg') +')'}"
        ></li>
        <!-- <li
          :class="[index == 2 ? 'show' : '']"
          :style="{ backgroundImage: 'url(' + require('../../static/images/bg3.jpg') +')' }"
        ></li> -->
      </ul>
    </div>
    <div>
      <ul class="cir">
        <li>
          <span :class="[index == 0 ? 'show' : '']"></span>
        </li>
        <li>
          <span :class="[index == 1 ? 'show' : '']"></span>
        </li>
        <!-- <li>
          <span :class="[index == 2 ? 'show' : '']"></span>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import * as loginAPI from "@/api/login.js";
import config from "../../config/config";

export default {
  data() {
    return {
      index: 0, // 切换图片的下标
      funList: [],
      userInfo: {},
      id1: false,
      id2: false,
      oaUrl: "",
      mediaUrl: ""
    };
  },
  created() {
    this.userInfo = this._util.getStorage('ssoUserInfo')

    this.oaUrl = `${config.toUrl}/oa/#/?accountId=${this.userInfo.accountId}&accessToken=${this.userInfo.accessToken}`
    this.mediaUrl = `${config.toUrl}/newmedia/#/?accountId=${this.userInfo.accountId}&accessToken=${this.userInfo.accessToken}&generalGroupId=${this.userInfo.generalGroupId}&orgId=${this.userInfo.orgId}&orgName=${this.userInfo.orgName}&name=${this.userInfo.name}`


    setInterval(() => {
      if (this.index == 1) {
        this.index = 0;
      } else {
        this.index = this.index + 1;
      }
    }, 10000);
    this.getRoleFunList()
    this.getSysList()
  },
  methods: {
      gosetting(a) {
        if(a !== '/exit') {
          this.$router.push({
            path:a
          })
        } else {
            // localStorage.clear();
            this._util.rmStroage("ssoUserInfo")
            this._util.rmStroage("ssoNav")
            window.localStorage.clear();
            // window.location = window.expertConfig.newUrl+'exit';
          let data = {
            accountId: this.userInfo.accountId
          }
           loginAPI.dologOut(data).then(res => {
             if(res.code == 0) {
               this.$router.push({
                 path: '/'
               })
             }
           })
        }
        
    },
    getRoleFunList() {
      let data = {
        accountId: this.userInfo.accountId
      }
      loginAPI.getRoleFunList(data).then(res => {
          if (res.code == 0) {
            this.funList = res.data.funList
            if(this.funList.length>0){
              this._util.setStorage('ssoNav',res.data.funList[0].funSonList)
            }
          }
      })
    },
    getSysList() {
      let data = {
        accountId: this.userInfo.accountId
      }
      loginAPI.getSysList(data).then(res => {
        if (res.code == 0) {
          if(res.data.oaSystem) {
              this.id1 = true
          } 
          if(res.data.recordSystem) {
              this.id2 = true
          }
          if(this.id1 == false && this.id2 == false) {
            this.$message.error("当前没有系统权限，请联系管理员！");
          }
        }
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .loginindex {
    height: 100vh;
    width: 100%;
    background-size: cover;
    /* transition: all 2s; */
    position: relative;
  }
  .loginindex .login-box {
    position: absolute;
    right: 10%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 400px;
    box-sizing: border-box;
    padding: 25px;
    z-index: 100;
  }
  .loginindex .login-box .login-title {
    margin-top: 15px;
    text-align: center;
    font-size: 22px;
  }
  .ico {
    width: 40px;
    height: 40px;
  }
  .ico.oa {
    background: url('../assets/images/OA.png') no-repeat center center /40px 40px;
    margin-right: 20px;
  }
  .ico.media {
    background: url('../assets/images/media.png') no-repeat center center /40px 40px;
    margin-right: 20px;

  }
  .userSet {
    background: url('../assets/images/userset.png') no-repeat center center /40px 40px;
    margin-right: 20px;
    cursor: pointer;
    width: 60px;
    height: 60px;
  
  }
  
  .onebox {
    background: rgba(15, 40, 71, 0.6);
    width: 500px;
    height: 60px;
    line-height: 60px;
    padding: 20px;
    font-size: 25px;
    color: #fff;
    margin-bottom: 80px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .onebox:hover {
    background: #0f2847;

  }
  .userSetBox {
    position: relative;
    z-index: 1000;
  }
  .userinfo_box {
  float: right;
  margin-right: 5%;
  margin-top: 2%;
}
.userinfo_box .user_box {
  float: left;
  border-left: 1px solid #a5aabb;
  height: 18px;
  line-height: 18px;
  margin-top: 23px;
  margin-left: 12px;
  font-size: 0;
  position: relative;
}
.userinfo_box .user_box div.user_img {
  margin: 0 12px;
  cursor: pointer;
  display: flex;
}
.userinfo_box .user_box div.user_img img {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: top;
  margin-top: 1px;
  border: 0px none;
}
.userinfo_box .user_box div.user_img span.user_name {
  font-size: 14px;
  color: #fff;
  white-space: nowrap
}
.userinfo_box .user_box .subset_nav {
  position: absolute;
  top: 26px;
  left: -8px;
  padding: 10px 0;
  margin: 5px 0;
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: 96px;
  display: none;
}
.userinfo_box .user_box .el-dropdown:hover .subset_nav {
  display: block;
}
.userinfo_box .user_box .subset_nav li {
  list-style: none;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  outline: 0;
  width: auto;
  height: auto;
}
.userinfo_box .user_box .subset_nav li:hover {
  background-color: #ecf5ff;
}
.userinfo_box .user_box .subset_nav li:hover a {
  color: #409eff;
}
.userinfo_box .user_box .subset_nav li a {
  font-size: 14px;
  font-family: "\5B8B\4F53";
  color: #606266;
}
.userinfo_box .user_box .subset_nav li a:hover {
  color: #409eff;
}
.userinfo_box .user_box .subset_nav li a.hover {
  color: #409eff;
}
.userinfo_box .user_box .subset_nav .popper__arrow,
.userinfo_box .user_box .subset_nav .popper__arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.userinfo_box .user_box .subset_nav .popper__arrow {
  border-width: 6px;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
  left: 50%;
  top: -6px;
  border-top-width: 0;
  border-bottom-color: #ebeef5;
  margin-left: -6px;
}
.userinfo_box .user_box .subset_nav .popper__arrow::after {
  content: " ";
  border-width: 6px;
  border-bottom-color: #fff;
  border-top-width: 0;
  margin-left: -6px;
  top: 1px;
}
.bg li {
        position: fixed;
        left: 0;top: 0;
        bottom: 0; right: 0;
        background-size: cover;  
        transition: all 1s;
        opacity: 0;

    }
    .bg li.show {
        opacity: 1;
    }
    .cir {
        position: absolute;
        left: 50%;
        bottom: 5%;
        transform: translateX(-50%);
        display: flex;
        justify-content: center;
    }
    .cir li {
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
    }
    .cir li span{
        display: inline-block;
      
      margin: 0 auto;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      /* margin-right: 50px; */
      background: #f0f0f0;
    }
    .cir span.show {
        background: #409eff;
    }
</style>



// WEBPACK FOOTER //
// src/components/LoginIndex.vue